import React from "react";
import { CheckIcon, GlobeIcon, LockIcon, LibraryIcon, GiftIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { CountdownTimer } from "./CountdownTimer";
import { ScarcityBar } from "./ScarcityBar";
import { SectionHeading } from "./Section";
import { bonuses } from "../data/landing";
const priceIncludes = ["Instant digital access", "Six educational volumes", "Five specialized professional resources", "No recurring subscription", "Seven-day refund guarantee"];
export function Offer() {
  return <section id="offer" className="w-full bg-ink" data-id="element-195" data-mp="p1l7t8dlevyt">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 md:py-24" data-id="element-196" data-mp="13xkdkcd8ck0s">
        <SectionHeading eyebrow="Your special launch offer" title="Everything You Need to Build a More Organized Clinical Reference Library" intro="Here is everything included when you purchase HOF CLINICAL BLUEPRINT™ today." data-id="element-197" data-mp="13uogsrd4c1dx" />

        <div className="mt-12 grid items-start gap-8 lg:grid-cols-[1fr_440px]" data-id="element-198" data-mp="2acl9ii29927d">
          <div className="space-y-5" data-id="element-199" data-mp="pj5ucnay2gdh">
            <div className="rounded-3xl bg-panel p-6 ring-1 ring-line sm:p-8" data-id="element-200" data-mp="pmbh3vw3p661">
              <div className="flex items-center gap-3" data-id="element-201" data-mp="uhqw4r5uh841">
                <LibraryIcon className="h-6 w-6 shrink-0 text-gold" aria-hidden="true" data-id="element-202" data-mp="zhvdskiho8vu" />
                <h3 className="text-base font-extrabold uppercase tracking-wide text-cream sm:text-lg" data-id="element-203" data-mp="13jqafbph5y3a">
                  Six-Volume Collection
                </h3>
              </div>
              <p className="mt-3 text-base leading-relaxed text-muted" data-id="element-204" data-mp="bstxkb3eztg0">
                Six specialized educational volumes covering clinical safety, facial anatomy, complication recognition,
                vascular warning signs, injectable treatment complications, and patient documentation.
              </p>
            </div>

            <div className="rounded-3xl bg-panel p-6 ring-1 ring-line sm:p-8" data-id="element-205" data-mp="3k9fc07etfeqi">
              <div className="flex items-center gap-3" data-id="element-206" data-mp="3o9z9jc3awkd6">
                <GiftIcon className="h-6 w-6 shrink-0 text-gold" aria-hidden="true" data-id="element-207" data-mp="3o8edtj592vdq" />
                <h3 className="text-base font-extrabold uppercase tracking-wide text-cream sm:text-lg" data-id="element-208" data-mp="vefqxvm3lsxx">
                  Five Specialized Bonuses
                </h3>
              </div>
              <ul className="mt-4 space-y-3" data-id="element-209" data-mp="154ikbwx4t8ws">
                {bonuses.map(b => <li key={b.number} className="flex gap-3 text-base leading-snug text-cream" data-id="element-210" data-mp="1067b9oenv2fm">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-gold text-xs font-black text-ink" data-id="element-211" data-mp="cg37nh1h32om">
                      B{b.number}
                    </span>
                    {b.title}
                  </li>)}
              </ul>
            </div>

            <p className="px-1 text-base leading-relaxed text-muted" data-id="element-212" data-mp="hfpu8h36xva3">
              You do not need to purchase multiple separate reference materials to get started. I have organized the
              material into one digital library so you can study the topics, review the educational resources, and
              adapt the relevant templates to your professional setting.
            </p>
          </div>

          <div className="rounded-[28px] bg-panel p-6 ring-2 ring-gold sm:p-8 lg:sticky lg:top-6" data-id="element-213" data-mp="25ery427vsde1">
            <p className="text-center text-sm font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-214" data-mp="1qhj3mzna6ti3">Your price today</p>
            <p className="mt-2 text-center font-serif text-7xl font-extrabold leading-none text-cream sm:text-8xl" data-id="element-215" data-mp="1vg2qd29p89bi">
              $27
              <span className="ml-2 align-top font-sans text-2xl font-bold text-gold" data-id="element-216" data-mp="2o48dfvo86aei">USD</span>
            </p>
            <p className="mt-2 text-center text-sm font-bold uppercase tracking-widest text-muted" data-id="element-217" data-mp="29flmewp8ju7g">One-time payment</p>

            <ul className="mt-6 space-y-2.5" data-id="element-218" data-mp="2edn4beaxdnhc">
              {priceIncludes.map(item => <li key={item} className="flex items-center gap-3 text-base text-cream" data-id="element-219" data-mp="323hl26yd7w6v">
                  <CheckIcon className="h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-220" data-mp="36v9age5sbvvf" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 flex justify-center" data-id="element-221" data-mp="1e7b971fk2ops">
              <CTAButton size="xl" label="Get HOF Clinical Blueprint™ for $27" className="sm:w-full sm:px-5" data-id="element-222" data-mp="1e6i8ah3a2tfk" />
            </div>
            <p className="mt-3 flex items-center justify-center gap-1.5 text-xs text-muted" data-id="element-223" data-mp="19ab6n0hx043f">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-224" data-mp="14b8ak5jwx87l" />
              One-time payment · Instant access · Seven-day guarantee
            </p>

            <div className="mt-6" data-id="element-225" data-mp="1wxjb5g7ir94e">
              <CountdownTimer data-id="element-226" data-mp="1wykue7yov1x7" />
            </div>

            <div className="mt-6" data-id="element-227" data-mp="1s6knfvk7b8r4">
              <ScarcityBar data-id="element-228" data-mp="1s5i2035ndyil" />
            </div>

            <div className="mt-4 flex gap-3 rounded-2xl bg-ink p-4 ring-1 ring-line" data-id="element-229" data-mp="1n89fjqdgv8bj">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-230" data-mp="2kndk3mopwdjd" />
              <p className="text-sm leading-snug text-cream" data-id="element-231" data-mp="2kp87r8rdijr5">
                <strong data-id="element-232" data-mp="2fvvkp32cel0i">Automatic currency conversion.</strong>{" "}
                <span className="text-muted" data-id="element-233" data-mp="2o5t3mh080ncw">
                  Your price is converted automatically to your local currency according to your country and payment
                  provider.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}